
(function () {
  /* TUEV-18 (Chris 2026-08-16): section.id kommt nicht mehr fuenfmal aus Liquid,
     sondern EINMAL vom eigenen Script-Tag. document.currentScript zeigt waehrend
     der synchronen Ausfuehrung eines klassischen externen Scripts genau auf
     dieses Tag — dadurch traegt jede Section-Instanz ihren eigenen Wert und
     zwei Instanzen koennen sich nicht gegenseitig ueberschreiben. Eine globale
     window-Config waere genau hier kollisionsanfaellig. */
  var LMM_SECTION_ID = (function () {
    var eigenes = document.currentScript;
    if (!eigenes) {
      eigenes = document.querySelector('script[data-lmm-tech-searchpage][data-lmm-section-id]');
    }
    return (eigenes && eigenes.getAttribute('data-lmm-section-id')) || '';
  })();
  if (window.__lmmTechSearchInit) { return; }
  window.__lmmTechSearchInit = true;

  /* One bounded recovery lifecycle per page generation, including guarded DOM work. */
  function neuerSuchLauf() {
    var lauf = { pending: 0, status: 'idle', settled: false, failedCount: 0, search: window.location.search, timer: null, cancel: [] };
    window.__lmmSearchRecoveryState = window.__lmmSearchResultsStatus = lauf;
    return lauf;
  }
  var suchLauf = neuerSuchLauf();
  function rankingMelden() {
    document.dispatchEvent(new CustomEvent('lmm:search-ranked'));
  }
  function recoveryMelden(lauf) {
    document.dispatchEvent(new CustomEvent('lmm:search-recovery-settled', {
      detail: { status: lauf.status, failedCount: lauf.failedCount }
    }));
    rankingMelden();
  }
  function laufAktiv(lauf) {
    return lauf === suchLauf && lauf.status !== 'aborted' && lauf.search === window.location.search;
  }
  function laufBeenden(lauf, status) {
    if (lauf.settled) { if (status === 'aborted') lauf.status = status; return; }
    if (lauf.timer) window.clearTimeout(lauf.timer);
    lauf.timer = null;
    lauf.status = status;
    lauf.settled = true;
    lauf.cancel.slice().forEach(function (fn) { fn(); });
    lauf.pending = 0;
    recoveryMelden(lauf);
  }
  function sucheBeobachten(promise, anwenden) {
    var lauf = suchLauf;
    if (!laufAktiv(lauf)) {
      Promise.resolve(promise).then(function () {}, function () {});
      return Promise.resolve(null);
    }
    if (!lauf.settled) {
      lauf.pending += 1;
      lauf.status = 'pending';
      if (!lauf.timer) lauf.timer = window.setTimeout(function () { laufBeenden(lauf, 'timeout'); }, 4000);
    }
    return new Promise(function (resolve) {
      var done = false;
      function fertig(fehler, wert) {
        if (done) return;
        done = true;
        var pos = lauf.cancel.indexOf(abbrechen);
        if (pos !== -1) lauf.cancel.splice(pos, 1);
        if (laufAktiv(lauf)) {
          try { if (!fehler && anwenden) anwenden(wert); } catch (e) { fehler = e; }
          if (fehler) lauf.failedCount += 1;
        }
        lauf.pending = Math.max(0, lauf.pending - 1);
        if (laufAktiv(lauf) && !lauf.settled && lauf.pending === 0) {
          window.clearTimeout(lauf.timer); lauf.timer = null;
          lauf.status = lauf.failedCount ? 'partial_error' : 'complete';
          recoveryMelden(lauf);
        }
        resolve(null);
      }
      // The telemetry deadline resolves the observer, but the fetch may still render.
      // Navigation invalidates the generation through laufAktiv instead.
      function abbrechen() { resolve(null); }
      if (!lauf.settled) lauf.cancel.push(abbrechen);
      else resolve(null);
      Promise.resolve(promise).then(function (wert) { fertig(null, wert); }, function (fehler) { fertig(fehler); });
    });
  }
  function suchNavigation() {
    if (suchLauf.pending || suchLauf.settled) laufBeenden(suchLauf, 'aborted');
    suchLauf = neuerSuchLauf();
  }
  document.addEventListener('lmm:content-swapped', suchNavigation);
  document.addEventListener('lmm:search-content-swapped', suchNavigation);

  function ordne() {
    var T = window.LMMTechRank;
    if (!T || !window.URLSearchParams) { return; }
    var sp;
    try { sp = new URLSearchParams(window.location.search); } catch (e) { return; }
    var q = sp.get('q');
    if (!q) { return; }
    var liste = document.getElementById('productList');
    if (window.LMMExactProductSearch && window.LMMExactProductSearch.full(liste, q)) return;
    var karten = liste ? liste.querySelectorAll('article.prow') : [];

    /* Fallback-Stufe: Die strenge Kandidatenstufe lief, liefert aber NICHTS.
       Gemessener Leerfall: 16W/999 G13.

       GESTUFT seit 2026-08-16 (TUEV-13A). Bis dahin wurden in diesem Fall ALLE
       Filter verworfen und die Anfrage lief ungefiltert weiter (lmm_tech=0) —
       bei einer Retrofit-Formulierung also von "0 Treffer" direkt auf die
       aufgeweichte, teils gedeckelte Gesamtmenge.

       Ursache (Befund suche-03 des Gesamt-TUEV, hier katalogweit nachgerechnet
       gegen 8.401 aktive Produkte): filterParams() setzt specs.wattage. Bei
       "GU10 50W 927" ist 50 W aber die ERSETZTE Leistung des alten Leuchtmittels,
       nicht die Eigenleistung des Produkts. Von 104 gaengigen Sockel/Watt/
       Farbcode-Kombinationen haben 22 katalogweit NULL Produkte mit
       specs.wattage = W UND specs.kelvin = K — die leere Seite ist dort also
       nicht Zufall, sondern zwingend. In genau diesen 22 Faellen hat die
       bereits vorhandene Ersatzleistungs-Stufe (ersatzFilterParams, seit
       2026-07-30 im Einsatz und als Nachladestufe belegt) zwischen 15 und 413
       Kandidaten.

       Deshalb: erst die Ersatzleistung versuchen (markiert durch lmm_tech=2),
       und erst wenn auch die leer bleibt, alle Filter verwerfen (lmm_tech=0).
       Keine neue Heuristik, keine neue Filtersemantik — dieselben Parameter,
       dieselbe Engine, nur eine Zwischenstufe statt eines Totalverzichts. */
    if ((sp.get('lmm_tech') === '1' || sp.get('lmm_tech') === '2') && karten.length === 0) {
      var weit = new URLSearchParams(window.location.search);
      var raus = [];
      weit.forEach(function (wert, name) {
        if (name.indexOf('filter.') === 0) { raus.push(name); }
      });
      raus.forEach(function (name) { weit.delete(name); });
      var ersatzPaare = [];
      if (sp.get('lmm_tech') === '1') {
        try { ersatzPaare = T.ersatzFilterParams(T.parse(q)) || []; } catch (fehler) { ersatzPaare = []; }
      }
      if (ersatzPaare.length) {
        /* Wiederholte Werte desselben Parameters verknuepft Shopify mit ODER —
           append statt set, sonst bliebe nur der letzte Wert stehen. */
        ersatzPaare.forEach(function (paar) { weit.append(paar[0], paar[1]); });
        weit.set('lmm_tech', '2');
      } else {
        weit.set('lmm_tech', '0');
      }
      if (T.kanonischeQuery && T.istKompaktOderTypo && T.istKompaktOderTypo(q)) {
        var kanonFallback = T.kanonischeQuery(q);
        if (kanonFallback) weit.set('q', kanonFallback);
      }
      try {
        if (T.hashQuery) {
          var marker = JSON.parse(window.sessionStorage.getItem('lmm_s_try') || 'null');
          var valid = marker && Object.keys(marker).sort().join(',') === 'canonical_split_applied,hop_type,target_hash,ts'
            && typeof marker.ts === 'number' && Date.now() >= marker.ts && Date.now() - marker.ts < 15000
            && marker.target_hash === T.hashQuery(q) && ['canonical','filter'].indexOf(marker.hop_type) !== -1;
          window.sessionStorage.setItem('lmm_s_try', JSON.stringify({
            ts: Date.now(), target_hash: T.hashQuery(weit.get('q') || q), hop_type: 'filter',
            canonical_split_applied: !!(kanonFallback && kanonFallback !== q) || !!(valid && marker.canonical_split_applied === true)
          }));
        }
      } catch (speicherFehler) {
        try { window.sessionStorage.removeItem('lmm_s_try'); } catch (_) {}
      }
      window.location.replace(window.location.pathname + '?' + weit.toString());
      return;
    }
    if (!karten.length) {
      /* KORREKTURRUNDE 3 (Chris Phase 5): Liefert die native Suche fuer eine
         kompakte technische Schreibweise ("13w840", "g 9 2,6 w") gar nichts,
         wird EINMAL die deterministisch zerlegte Schreibweise nachgeladen.
         Sichtbare Suchanfrage und H1 bleiben unveraendert. */
      schreibweisenStufeLaden(liste, q);
      /* KORREKTURRUNDE 4: auch ohne native Karten darf ein ausdruecklicher
         Sockel seine verifizierten Kandidaten nachladen (Chris Phase 6). */
      var specLeer = T.parse(q);
      var RLeer = window.LMMRelevance;
      var analyseLeer = null;
      if (RLeer) { try { analyseLeer = RLeer.analyze(q); } catch (e2) { analyseLeer = null; } }
      if (analyseLeer && specLeer.sockel && !analyseLeer.identifier) {
        sockelStufeLaden(liste, specLeer, T, q, analyseLeer);
      }
      return;
    }
    /* Gemeinsamen Bestseller-Index anstossen, sobald echte Treffer da sind:
       auf einer direkt aufgerufenen Suchseite laeuft integrate() im Header nie,
       der Index bliebe sonst leer. Dieselbe Ladefunktion, dieselben Seiten,
       derselbe sessionStorage-Cache wie im Dropdown — wer vorher das Dropdown
       benutzt hat, laedt hier gar nichts nach. */
    if (window.LMMBestSellerIndex && typeof window.LMMBestSellerIndex.ensureLoaded === 'function') {
      window.LMMBestSellerIndex.ensureLoaded();
    }
    var spec = T.parse(q);
    /* AENDERUNG 2026-08-04 (Chris): Bis hierher lief die Rangfolge NUR bei einer
       als technisch erkannten Query (>= 2 strukturierte Werte). Bei allem
       anderen — "Philips TUV 11W", "LED Leuchtroehre", "18W" — blieb die
       Shopify-Reihenfolge stehen. Jetzt ordnet window.LMMRelevance jede
       Anfrage; die technische Klasse bleibt eine Komponente darin. */
    var R = window.LMMRelevance;
    var analyse = null;
    if (R) { try { analyse = R.analyze(q); } catch (e) { analyse = null; } }
    if (!analyse && !spec.technisch && sortModus() !== 'stock-descending' && sortModus() !== 'stock-ascending') { return; }

    ordneListe(liste, spec, T, analyse);
    /* Zweite Stufe erst NACH der Sortierung — sie haengt hinten an.
       ERWEITERT 2026-08-13 (Chris Phase 12, Kollegen-Fall "GU10 50W 927
       120°"): auch im Rueckfallzustand lmm_tech=0. Genau dort fehlten die
       fachlich exakten Ersatzkandidaten, deren Titel die gesuchte Wattzahl
       nicht woertlich enthaelt ("7-51W" bei einer 50-W-Anfrage) — die
       Textsuche kann sie nie liefern, nur der strukturierte Filter. */
    var lmmTech = sp.get('lmm_tech');
    /* Preis-Modi (2026-08-13): die ERGAENZUNGSSTUFEN (Ersatz/Familie/Sockel)
       fuegen Kandidaten ausserhalb der preissortierten Servermenge ein und
       wuerden die Preisreihenfolge zerreissen — sie pausieren dort. Die
       SEITENSTUFE unten bleibt aktiv: sie laedt dieselbe Menge seitenweise
       in Serverreihenfolge nach und ist damit preis-stabil. */
    var stufenErlaubt = sortModus() !== 'preis';
    if (stufenErlaubt && spec.technisch && (lmmTech === '1' || lmmTech === '0' || spec.wattModus === 'ambiguous')) { ersatzStufeLaden(liste, spec, T, q, analyse); }
    /* SEITENSTUFE (Chris 2026-08-11): Die Seite ist durch die strenge
       Kandidatenstufe bereits serverseitig verengt (lmm_tech=1) — gerankt wurde
       bisher aber nur die ERSTE Shopify-Paginationsseite. Belegter Fall vom
       2026-08-11: q="18W Leuchtstoffroehre durch LED ersetzen" -> 90 Treffer auf
       4 Seiten. Die meistverkaufte unbewertete Roehre (Bestseller-Rang 1367) und
       die einzige mit 5,0 aus 5 Bewertungen (Rang 550) liegen auf Seite 2 und
       konnten deshalb NIE nach vorn kommen, egal wie gut sie bewertet sind.
       Ist der bereits verengte Satz ueberschaubar, werden die restlichen Seiten
       DESSELBEN Ergebnisses nachgeladen und gemeinsam gerankt. */
    var modus = sortModus();
    var pageParam = sp.get('page');
    if (analyse && !analyse.identifier && (sp.get('lmm_tech') === '1' || modus === 'stock-descending' || modus === 'stock-ascending') && (!pageParam || pageParam === '1')) {
      seitenStufeLaden(liste, spec, T, q, analyse);
    }
    /* KORREKTURRUNDE 2: reine Familienanfrage ("LED Leuchtroehre", "LED Tube",
       …) — denselben fachlichen Bestand nachladen wie alle Schreibweisen. */
    if (stufenErlaubt && analyse && analyse.familie && (analyse.restTokens || []).length === 0) {
      familienStufeLaden(liste, spec, T, q, analyse);
    }
    /* KORREKTURRUNDE 4 (Chris Phase 6): Bei einem ausdruecklich erkannten
       Sockel wird geprueft, ob genug exakte Sockelkandidaten sichtbar sind —
       sonst wird EINMAL die kanonische Sockelanfrage nachgeladen, jede Karte
       gegen ALLE harten Bedingungen verifiziert und per Product-ID
       dedupliziert eingefuegt. */
    if (stufenErlaubt && analyse && spec.sockel && !analyse.identifier) {
      sockelStufeLaden(liste, spec, T, q, analyse);
    }
    /* Reichweite der Sortierung ausweisen, sobald der Poolzustand feststeht
       (TUEV-13C). Laeuft die Seitenstufe noch, meldet poolVollstaendig null und
       der Hinweis wird erst nach dem Einfuegen gesetzt. */
    sortumfangAnzeigen(poolVollstaendig(liste));
  }

  /* Typ-Gruppen: .type-divider, danach die zugehoerigen .prow bis zum naechsten Trenner. */
  function gruppenVon(liste) {
    var gruppen = [];
    var aktuell = null;
    Array.prototype.forEach.call(liste.children, function (el) {
      if (el.classList && el.classList.contains('type-divider')) {
        aktuell = { trenner: el, zeilen: [] };
        gruppen.push(aktuell);
      } else if (el.classList && el.classList.contains('prow')) {
        if (!aktuell) { aktuell = { trenner: null, zeilen: [] }; gruppen.push(aktuell); }
        aktuell.zeilen.push(el);
      }
    });
    return gruppen;
  }

  var stockDomIndex = 0;
  function ganzzahl(wert, fallback) {
    var zahl = parseInt(wert, 10);
    return isFinite(zahl) ? zahl : fallback;
  }

  function datenVon(el) {
    /* Titel aus data-wish-title, nicht aus einem Klassennamen: die Karte
       rendert die Ueberschrift als <h3><a>…</a></h3>, ein geratenes .ptitle
       gab im ersten Canary-Lauf einen leeren Titel — damit fiel das
       Zielprodukt von Klasse 1 (Titelphrase) auf Klasse 2 zurueck und stand
       hinter den kaufbaren LED-Roehren. */
    var wish = el.querySelector('[data-wish-title]');
    var h3 = el.querySelector('h3');
    return {
      titel: wish ? (wish.getAttribute('data-wish-title') || '')
        : (h3 ? h3.textContent : ''),
      watt: el.getAttribute('data-watt'),
      ersatzWatt: el.getAttribute('data-rwatt'),
      sockel: el.getAttribute('data-base'),
      farbcode: el.getAttribute('data-colorcode'),
      /* data-ptype ist der Bucket des Suchklassifizierers (leuchtmittel |
         adapter | leuchte | zubehoer) — damit erkennt die Rangfolge eine
         komplette Leuchte, auch wenn diese specs.base=G13 traegt. */
      bucket: el.getAttribute('data-ptype'),
      /* KORREKTURRUNDE 2: fuer die Produktfamilie zaehlt der GEPFLEGTE
         Shopify-Produkttyp. Der grobe Bucket bleibt als Rueckfallebene, damit
         eine Karte ohne gepflegten Typ nicht ploetzlich typlos wird. */
      typ: el.getAttribute('data-ptype-fine') || el.getAttribute('data-ptype'),
      kaufbar: el.getAttribute('data-buyable') !== '0',
      stockQty: ganzzahl(el.getAttribute('data-stock-qty'), 0),
      stockTier: ganzzahl(el.getAttribute('data-stock-tier'), 3),
      /* Ergaenzt 2026-08-04: identischer Rankingdatensatz wie im Dropdown. */
      vendor: el.getAttribute('data-vendor') || '',
      sku: el.getAttribute('data-sku') || '',
      ean: el.getAttribute('data-ean') || el.getAttribute('data-gtin') || '',
      mpn: el.getAttribute('data-mpn') || '',
      kelvin: el.getAttribute('data-kelvin') || '',
      lumen: el.getAttribute('data-lumen') || '',
      lichtfarbe: el.getAttribute('data-lightcolor') || '',
      laenge: el.getAttribute('data-length') || '',
      /* Abstrahlwinkel + CRI (2026-08-13): dieselben Collection-Filterfelder
         specs.beam_angle / specs.cri, gerendert in lmm-search-product-card. */
      beam: el.getAttribute('data-beam') || '',
      cri: el.getAttribute('data-cri') || '',
      bewertung: el.getAttribute('data-rating') || '',
      bewertungen: el.getAttribute('data-ratingcount') || '',
      bestRang: bestRangVon(el),
      zusatzText: [el.getAttribute('data-sku'), el.getAttribute('data-ean'),
        el.getAttribute('data-gtin'), el.getAttribute('data-mpn'),
        el.getAttribute('data-vendor'), el.getAttribute('data-ptype'),
        el.getAttribute('data-lightcolor'), el.getAttribute('data-shape'),
        el.getAttribute('data-formfactor'), el.getAttribute('data-ballast')]
        .filter(Boolean).join(' ')
    };
  }

  /* ---- Bestseller-Rang auf der vollstaendigen Suchseite (2026-08-11) -------
     Bis hierher stand in datenVon hart bestRang:null. Die Suchseite benutzte
     damit zwar dieselbe Rangfolge wie das Dropdown, deren Bestsellerstufe war
     hier aber wirkungslos: fachlich gleichwertige, unbewertete Produkte
     blieben in Shopify-Reihenfolge stehen. Gemessen an "LED Roehre die 58W
     ersetzt" — 24 Treffer, 23 ohne Bewertung, echte Raenge 1.308 bis 5.309.

     Der Rang kommt aus GENAU DEM Index, den auch das Dropdown benutzt
     (window.LMMBestSellerIndex, nur lesend). Schluessel ist die
     Shopify-Product-ID aus data-pid der Karte — kein Handle, kein URL-Pfad,
     keine Variant-ID. Kein zweiter Index, keine eigene Suchseiten-Sortierung,
     kein kuenstlicher Rang: ist ein Rang unbekannt, bleibt es beim bisherigen
     neutralen null, das die Rangfolge zu 999999999 aufloest. */
  function bestRangVon(el) {
    var index = window.LMMBestSellerIndex;
    if (!index || typeof index.getRank !== 'function') { return null; }
    var pid = el.getAttribute('data-pid');
    if (!pid) { return null; }
    try { return index.getRank(pid); } catch (fehler) { return null; }
  }

  /* Der Index waechst seitenweise nach (8.500 Produkte, 34 Seiten). Wird ein
     bisher unbekannter Rang bekannt, ordnet die Liste EINMAL nach — mit
     demselben Comparator, ohne neue Anfrage, ohne Neurendern und ohne die
     Nachladestufen erneut anzustossen. Gebuendelt wird bereits an der Quelle
     (250 ms in lmm-bestseller-sort-part-1), hier kommt also hoechstens ein
     Signal je Nachladewelle an; der Vorgang ist endlich, weil der Index
     endlich ist.

     Wie im Dropdown gilt: hat der Kunde bereits gescrollt, bleibt die
     sichtbare Reihenfolge stehen — sonst springt ihm die Liste unter dem
     Finger weg. ordneListe schreibt ausserdem nur dann ins DOM, wenn sich die
     Reihenfolge tatsaechlich aendert. */
  function neuOrdnen() {
    var T = window.LMMTechRank;
    if (!T || !window.URLSearchParams) { return; }
    var sp;
    try { sp = new URLSearchParams(window.location.search); } catch (fehler) { return; }
    var q = sp.get('q');
    if (!q) { return; }
    var liste = document.getElementById('productList');
    if (!liste || !liste.querySelector('article.prow')) { return; }
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 8) { return; }
    var spec = T.parse(q);
    var R = window.LMMRelevance;
    var analyse = null;
    if (R) { try { analyse = R.analyze(q); } catch (fehler) { analyse = null; } }
    if (!analyse && !spec.technisch && sortModus() !== 'stock-descending' && sortModus() !== 'stock-ascending') { return; }
    ordneListe(liste, spec, T, analyse);
  }

  function zeigeWieder(el) {
    if (el.dataset.lmmTechHidden) {
      el.style.removeProperty('display');
      delete el.dataset.lmmTechHidden;
    }
  }

  /* Sortiermodus der Suchseite (Chris 2026-08-13): lmm_sort in der URL.
     Default = Bestseller (fachliche Kaskade, danach Bestseller-Rang).
     Preis-Modi sortiert der SERVER (natives sort_by) — das Client-JS ordnet
     dort bewusst NICHT um, sonst zerstoerte es die Preisreihenfolge. */
  function sortModus() {
    try {
      var m = new URLSearchParams(window.location.search).get('lmm_sort');
      if (m === 'relevance' || m === 'rating' || m === 'stock-descending' || m === 'stock-ascending') { return m; }
      if (m === 'price-ascending' || m === 'price-descending') { return 'preis'; }
    } catch (fehler) { /* Default greift */ }
    return 'best-selling';
  }

  /* ---- Reichweite der Sortierung ehrlich ausweisen (TUEV-13C, 2026-08-16) ----
     "Bestseller" und "Beste Bewertungen" ordnen genau den Kandidatenraum, der im
     DOM steht. Ist die Seitenstufe uebersprungen (mehr als fuenf Serverseiten),
     ist das nur die aktuelle Seite — dann darf die Auswahl keine Ordnung ueber
     die gesamte Treffermenge behaupten.
     Eine serverseitige Alternative gibt es nicht: Shopifys natives
     sort_by=best-selling ist auf /search wirkungslos — am 16.08.2026 erneut live
     nachgemessen (q=Osram, q=led, q="Philips Master": Kartenreihenfolge 24 von 24
     identisch zum Default, waehrend sort_by=price-ascending 0 von 24 haelt). */
  function poolVollstaendig(liste) {
    var zustand = liste.dataset.lmmPool;
    if (zustand === 'laedt') { return null; }          // noch offen -> nichts behaupten
    if (zustand === 'vollstaendig') { return true; }
    if (zustand === 'uebersprungen' || zustand === 'leer') { return false; }
    /* Ohne Pagination gibt es nur eine Serverseite: die Liste IST der
       vollstaendige Kandidatenraum. */
    return !document.querySelector('.lmm-pagination');
  }

  /* TUEV-21 (Chris 2026-08-17, Owner-Entscheid): Unter dem Sortier-Dropdown
     erscheint KEIN Sortierhinweis mehr — fuer keine Sortierung. Bis hierher
     stand dort je nach Modus ein Satz zur Reichweite der Bestseller- bzw.
     der Bewertungsreihenfolge (Wortlaut siehe TUEV-13C-Bericht und den
     Rollbackstand in _rollback_preview/). Die dahinterliegende
     Plattformgrenze (natives
     sort_by=best-selling ist auf /search wirkungslos, am 16.08.2026 live
     nachgemessen) bleibt im QA-/Audit-Bericht dokumentiert — nur die
     Kunden-UI entfaellt.
     Die Funktion bleibt als Aufraeumpfad bestehen und wird weiter von allen
     bisherigen Stellen aufgerufen: ein aus einem frueheren Zustand noch
     vorhandenes Hinweiselement wird restlos entfernt, damit unter der
     Toolbar keine leere Zeile zurueckbleibt. Das Element war rein
     JS-erzeugt (span mit Inline-Style) — es gibt dafuer kein Liquid-Markup
     und keine CSS-Regel, deshalb bleibt die Toolbar-Geometrie unberuehrt. */
  function sortumfangAnzeigen() {
    var hinweis = document.querySelector('[data-lmm-sort-umfang]');
    if (hinweis && hinweis.parentNode) { hinweis.parentNode.removeChild(hinweis); }
  }

  function kopieOhneBest(v) {
    var o = {};
    for (var k in v) { if (Object.prototype.hasOwnProperty.call(v, k)) { o[k] = v[k]; } }
    o.best = 0;
    return o;
  }

  function vergleicheImModus(a, b, modus, R, T) {
    if (modus === 'stock-descending' || modus === 'stock-ascending') {
      if (a.stockTier !== b.stockTier) { return a.stockTier - b.stockTier; }
      if (a.stockTier === 0 && a.stockQty !== b.stockQty) {
        return modus === 'stock-descending' ? b.stockQty - a.stockQty : a.stockQty - b.stockQty;
      }
      return a.domIndex - b.domIndex;
    }
    if (!(a.vektor && b.vektor && R)) { return T.vergleiche(a, b); }
    if (modus === 'rating') {
      /* Beste Bewertungen (Chris Phase 5): Rating absteigend, bei gleichem
         Rating Review-Anzahl absteigend, danach Bestseller, danach stabil.
         Unbewertete (bewertung=999) stehen dahinter. Harte Widersprueche
         blendet verstecke() unabhaengig vom Modus aus. */
      var av = a.vektor, bv = b.vektor;
      if (av.bewertung !== bv.bewertung) { return av.bewertung - bv.bewertung; }
      if (av.bewertungen !== bv.bewertungen) { return bv.bewertungen - av.bewertungen; }
      if (av.best !== bv.best) { return av.best - bv.best; }
      return 0;
    }
    if (modus === 'relevance') {
      /* Beste Treffer: die fachliche Kaskade OHNE Bestseller-Tiebreak —
         danach stabil die Serverreihenfolge (Shopify-Relevanz). */
      return R.vergleiche(kopieOhneBest(a.vektor), kopieOhneBest(b.vektor));
    }
    return R.vergleiche(a.vektor, b.vektor);
  }

  function ordneListe(liste, spec, T, analyse) {
    var R = window.LMMRelevance;
    var modus = sortModus();
    var alle = [];
    gruppenVon(liste).forEach(function (gruppe) {
      var zeilen = gruppe.zeilen;
      if (!zeilen.length) { return; }
      var bewertet = zeilen.map(function (el, i) {
        var daten = datenVon(el);
        /* Einmaliger Index bleibt bei Nachsortierung/Index-Updates stabil. */
        if (typeof el.__lmmStockDomIndex !== 'number') { el.__lmmStockDomIndex = stockDomIndex++; }
        var eintrag = { el: el, i: i, kaufbar: daten.kaufbar, vektor: null,
          stockQty: daten.stockQty, stockTier: daten.stockTier, domIndex: el.__lmmStockDomIndex };
        if (analyse && R) {
          var v = null;
          try { v = R.rank(analyse, daten); } catch (fehler) { v = null; }
          if (v) {
            eintrag.vektor = v;
            /* gewicht = fachliche Rangklasse; die strenge Kandidatenstufe
               unten benutzt denselben Schwellenwert wie das Dropdown. */
            eintrag.gewicht = v.klasse;
            el.setAttribute('data-lmm-r-klasse', String(v.klasse));
            el.setAttribute('data-lmm-r-warum', v.grund);
            el.setAttribute('data-lmm-r-hart', String(v.hart));
            el.setAttribute('data-lmm-r-sockel', String(v.sockel));
            el.setAttribute('data-lmm-r-technik', String(v.technik));
            el.setAttribute('data-lmm-r-fehl', String(v.fehl));
            el.setAttribute('data-lmm-r-bewertung', String(v.bewertung));
            el.setAttribute('data-lmm-r-bewertungen', String(v.bewertungen));
          }
        }
        if (eintrag.vektor === null) {
          var klasse = T.classify(spec, daten);
          eintrag.gewicht = T.gewicht(spec, klasse.klasse);
          el.setAttribute('data-lmm-tech-rank', String(eintrag.gewicht));
          el.setAttribute('data-lmm-tech-why', klasse.grund);
        }
        return eintrag;
      });
      alle = alle.concat(bewertet);
      if (zeilen.length < 2) { return; }
      /* Preis-Modi: Serverreihenfolge (= Shopify-Preissortierung) bleibt
         stehen; Rangvektoren und verstecke() laufen trotzdem. */
      if (modus === 'preis') { return; }
      var sortiert = bewertet.slice().sort(function (a, b) {
        var v = vergleicheImModus(a, b, modus, R, T);
        return v !== 0 ? v : a.i - b.i;
      });
      var unveraendert = sortiert.every(function (x, i) { return x.i === i; });
      if (unveraendert) { return; }
      var anker = zeilen[zeilen.length - 1].nextSibling;
      sortiert.forEach(function (x) { liste.insertBefore(x.el, anker); });
    });
    verstecke(alle);
    zaehlerNachziehen(liste);
    rankingMelden();
  }

  /* Strenge Kandidatenstufe auf der Suchseite (Chris §3) — dieselbe Regel wie
     im Dropdown: Solange mindestens ein fachlich exakter Treffer da ist
     (Klasse 1/2), verschwinden Zeilen, die KEINEN der gesuchten Werte tragen.
     Dazu gehoeren seit der zweiten Runde ausdruecklich der Titel-Wattwiderspruch
     (2 x 8 W ist keine 16-W-Lichtquelle) und komplette Leuchten bei einer
     Sockelanfrage. Ersatzprodukte (Klasse 4) bleiben sichtbar, nur hinten.
     display:none statt [hidden], weil die Karten per Klasse ein eigenes
     display tragen. Sicherung: wuerde nichts uebrig bleiben, wird nichts
     versteckt. */
  function verstecke(alle) {
    /* HARTE WIDERSPRUECHE (Korrekturrunde 4, Chris Phase 3/10): Karten mit
       strukturiert widersprechendem Sockel, widersprechender Produktgruppe,
       widersprechender Ersatz-/Eigenleistung, Kelvin, Farbcode oder Laenge
       sind KEINE regulaeren Treffer. Sie verschwinden IMMER — bewusst OHNE
       die Sicherung der weichen Stufe: lieber null Produktkarten als eine
       fachlich falsche Karte (Chris, Grundregel). */
    var hart = alle.filter(function (x) {
      return x.vektor && x.vektor.hart > 0;
    });
    var weich = alle.filter(function (x) { return hart.indexOf(x) === -1; });
    var streng = weich.filter(function (x) { return x.gewicht <= 2; });
    var raus = streng.length
      ? weich.filter(function (x) { return x.gewicht >= 5; })
      : [];
    if (!raus.length || raus.length >= weich.length) { raus = []; }
    alle.forEach(function (x) {
      if (hart.indexOf(x) !== -1 || raus.indexOf(x) !== -1) {
        x.el.style.display = 'none';
        x.el.dataset.lmmTechHidden = '1';
      } else {
        zeigeWieder(x.el);
      }
    });
  }

  /* Trefferzaehler duerfen nicht mehr Karten behaupten, als sichtbar sind. */
  function zaehlerNachziehen(liste) {
    var sichtbar = 0;
    var versteckt = 0;
    gruppenVon(liste).forEach(function (gruppe) {
      var n = 0;
      gruppe.zeilen.forEach(function (el) {
        if (el.dataset.lmmTechHidden) { versteckt += 1; } else { n += 1; }
      });
      sichtbar += n;
      if (gruppe.trenner) {
        /* Die Gruppenzaehler entfernt lmm-search-intent-engine-part-7 bewusst
           aus den Trennern; die Zuweisung greift deshalb heute nicht. Sie
           bleibt bewusst stehen, damit ein wieder eingeblendeter Zaehler nicht
           mit einer falschen Zahl zurueckkaeme. */
        var zaehler = gruppe.trenner.querySelector('[data-group-count]');
        if (zaehler) { zaehler.textContent = n + ' Treffer'; }
        gruppe.trenner.style.display = n ? '' : 'none';
      }
    });
    var ergaenzt = liste.querySelectorAll('article.prow[data-lmm-tech-quelle]').length;
    if (!versteckt && !ergaenzt) { return; }
    var zeile = document.getElementById('lmmResultCount');
    var hero = document.getElementById('lmmHeroCount');
    var seiten = document.querySelector('.lmm-pagination');
    /* NULL sichtbare Karten (Korrekturrunde 4, Chris Phase 7/11): kein
       sichtbarer Zaehler darf behaupten, ausgeschlossene Produkte seien
       passende Treffer. Ehrliche Keine-Treffer-Meldung statt falscher Karten;
       die Kategorieempfehlungen rechts bleiben unveraendert stehen. */
    var leer = document.querySelector('[data-lmm-hart-leer]');
    if (sichtbar === 0) {
      if (zeile) { zeile.textContent = 'Keine passenden Treffer'; }
      if (hero) { hero.setAttribute('hidden', ''); }
      if (seiten) { seiten.style.display = 'none'; }
      if (!leer && liste.parentNode) {
        var qLeer = '';
        try { qLeer = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { qLeer = ''; }
        leer = document.createElement('div');
        leer.className = 'empty-state';
        leer.setAttribute('data-lmm-hart-leer', '1');
        var kopf = document.createElement('p');
        kopf.className = 'empty-h';
        kopf.textContent = qLeer ? 'Keine passenden Treffer für „' + qLeer + '“' : 'Keine passenden Treffer';
        var sub = document.createElement('p');
        sub.className = 'empty-sub';
        sub.textContent = 'Zu dieser Suche gibt es keinen Artikel mit exakt passenden technischen Daten. Bitte prüfen Sie die Schreibweise oder nutzen Sie die passenden Kategorien.';
        leer.appendChild(kopf);
        leer.appendChild(sub);
        liste.parentNode.insertBefore(leer, liste.nextSibling);
      }
      return;
    }
    if (leer) { leer.remove(); }
    if (seiten) { seiten.style.removeProperty('display'); }
    if (zeile) {
      zeile.textContent = seiten
        ? sichtbar + ' technisch passende Treffer auf dieser Seite'
        : '1–' + sichtbar + ' von ' + sichtbar + ' Treffern';
    }
    if (hero) {
      /* Mit Pagination ist die Gesamtzahl nach dem Ausschluss unbekannt —
         ehrliche Untergrenze der aktuellen Seite statt der aufgeweichten
         Servermenge (Korrekturrunde 4, Chris Phase 11). */
      hero.textContent = seiten ? sichtbar + '+ Treffer' : sichtbar + ' Treffer';
      hero.removeAttribute('hidden');
    }
  }

  /* Deduplizierungsschluessel (Korrekturrunde 3, Chris Phase 10): FUEHREND ist
     die Shopify-Product-ID (data-pid der Karte) — dasselbe Produkt darf nicht
     doppelt erscheinen, nur weil es ueber eine andere Such- oder Collection-URL
     nachgeladen wurde. Der URL-Pfad bleibt ausschliesslich Rueckfallebene fuer
     Karten ohne Product-ID. */
  function schluessel(el) {
    var pid = el.getAttribute('data-pid');
    if (pid) { return 'pid:' + pid; }
    var a = el.querySelector('h3 a[href], a[href*="/products/"]');
    if (!a) { return ''; }
    var href = a.getAttribute('href') || '';
    return href.split('?')[0];
  }

  /* SCHREIBWEISEN-STUFE (Korrekturrunde 3, Chris Phase 5). Belegte Faelle vom
     04.08.2026: "13w840", "l36w 840", "g 9 2,6 w" — die native Suche liefert
     fuer die zusammengeklebte Schreibweise 0 Treffer, fuer die zerlegte den
     korrekten Bestand. Genau EINE ergaenzende native Zweitabfrage mit der
     deterministisch zerlegten Form (LMMTechRank.kanonischeQuery); dieselbe
     Engine bewertet und ordnet die Karten mit der ORIGINALEN Kundenanfrage.
     Kein Eingriff bei: Identifier-Anfrage, eigener Filterwahl, Folgeseiten
     oder wenn die Zerlegung nichts veraendert. */
  function schreibweisenStufeLaden(liste, q) {
    if (!window.fetch || !window.DOMParser || !window.LMMTechRank
        || !window.LMMTechRank.kanonischeQuery) { return; }
    if (window.__lmmSchreibweiseQ === q) { return; }
    var R = window.LMMRelevance;
    if (R && R.identifierQuery && R.identifierQuery(q)) { return; }
    var sp;
    try { sp = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (sp.get('page')) { return; }
    var filterDa = false;
    sp.forEach(function (wert, name) {
      if (name.indexOf('filter.') === 0) { filterDa = true; }
    });
    if (filterDa && sp.get('lmm_tech') !== '1' && sp.get('lmm_tech') !== '2') { return; }
    var kanon = null;
    try { kanon = window.LMMTechRank.kanonischeQuery(q); } catch (e) { return; }
    if (!kanon) { return; }
    window.__lmmSchreibweiseQ = q;
    var url;
    try { url = new URL(window.location.pathname, window.location.origin); }
    catch (e) { return; }
    url.searchParams.set('q', kanon);
    sp.forEach(function (wert, name) { if (name.indexOf('filter.') === 0) url.searchParams.append(name, wert); });
    url.searchParams.set('type', 'product');
    var vorschau = sp.get('preview_theme_id');
    if (vorschau) { url.searchParams.set('preview_theme_id', vorschau); }
    var zielUrl = url.pathname + url.search;
    url.searchParams.set('section_id', LMM_SECTION_ID);
    sucheBeobachten(window.fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (antwort) {
        if (!antwort.ok) { throw new Error('HTTP ' + antwort.status); }
        return antwort.text();
      }), function (html) { schreibweisenEinfuegen(liste, html, q, kanon, zielUrl); });
  }

  function schreibweisenEinfuegen(liste, html, q, kanon, zielUrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.getElementById('productList');
    var karten = neu ? neu.querySelectorAll('article.prow') : [];
    if (!neu || !karten.length) { return; }
    var gesamt = karten.length;
    var summe = doc.getElementById('lmmResultCount');
    if (summe) {
      var tref = /von\s+([\d.]+)/.exec(summe.textContent || '');
      if (tref) {
        var ausText = Number(String(tref[1]).replace(/\./g, ''));
        if (isFinite(ausText) && ausText > gesamt) { gesamt = ausText; }
      }
    }
    var kopie = document.importNode(neu, true);
    Array.prototype.forEach.call(kopie.querySelectorAll('article.prow'), function (el) {
      el.setAttribute('data-lmm-tech-quelle', 'schreibweise');
    });
    var trenner = kopie.querySelector('.type-divider');
    if (trenner && !trenner.querySelector('[data-lmm-schreibweise-note]')) {
      var hinweis = document.createElement('span');
      hinweis.className = 'td-note';
      hinweis.setAttribute('data-lmm-schreibweise-note', '1');
      hinweis.textContent = 'Treffer für die technische Schreibweise „'
        + kanon + '“.';
      trenner.appendChild(hinweis);
      if (gesamt > karten.length) {
        var mehr = document.createElement('a');
        mehr.className = 'td-note lmm-tech-mehr';
        mehr.href = zielUrl;
        mehr.textContent = 'Alle ' + gesamt + ' Treffer anzeigen';
        trenner.appendChild(mehr);
      }
    }
    /* Leere Trefferflaeche ersetzen: entweder das (leere) #productList oder der
       generische Leerzustand. Gibt es keins von beidem, wird nichts eingefuegt. */
    var ziel = liste || document.querySelector('#lmmMain .empty-state');
    if (!ziel || !ziel.parentNode) { return; }
    ziel.parentNode.replaceChild(kopie, ziel);
    var T = window.LMMTechRank;
    var spec = T.parse(q);
    var R = window.LMMRelevance;
    var analyse = null;
    if (R) { try { analyse = R.analyze(q); } catch (e) { analyse = null; } }
    if (analyse || spec.technisch) { ordneListe(kopie, spec, T, analyse); }
    else { zaehlerNachziehen(kopie); }
    if (analyse && spec.sockel && !analyse.identifier) {
      sockelStufeLaden(kopie, spec, T, q, analyse);
    }
  }

  /* SOCKELSTUFE (Korrekturrunde 4, Chris Phase 6). Belegte Faelle vom
     05.08.2026: "leuchtmittel g9" lieferte nativ 1000 aufgeweichte Treffer
     OHNE ein einziges G9-Leuchtmittel (Seite 1: G10q/G24d/G23/2G7), waehrend
     die native Anfrage "g9" 107 Treffer mit durchgaengig strukturiertem
     base=G9 liefert; "Ersatz fuer 6W E27" fand die beiden verifizierten
     E27-Ersatzprodukte nicht, "e27" + replaces_wattage=6.0 liefert exakt
     diese zwei. filter.p.m.specs.base bleibt als Suchfilter WIRKUNGSLOS
     (frisch gemessen 05.08.2026: identische Menge mit und ohne) — deshalb
     laeuft die Sockelverengung ueber diese kontrollierte Zweitabfrage.

     ARBEITSWEISE (dokumentierte Grenzen):
       · genau EINE zusaetzliche native Seite (24 Karten), keine weitere
         Pagination — Cache-Schluessel ist die Query (window.__lmmSockelQ),
         der HTTP-Cache uebernimmt Wiederholungen;
       · ausgeloest nur, wenn weniger als SOCKEL_MIN exakte Karten sichtbar
         sind; Stopp danach — der Katalog wird nie breit durchgeladen;
       · jede nachgeladene Karte wird mit der ORIGINALEN Kundenanfrage gegen
         ALLE harten Bedingungen geprueft (Sockel exakt belegt, Gruppe,
         Watt/Ersatz, Kelvin, Farbcode, Laenge) und ueber die Shopify-
         Product-ID dedupliziert. Die Collection-Empfehlung rechts bleibt
         unveraendert; es gibt keine automatische Weiterleitung. */
  var SOCKEL_MIN = 4;
  var SOCKEL_MAX = 24;

  function sockelStufeLaden(liste, spec, T, q, analyse) {
    if (!window.fetch || !window.DOMParser || !window.LMMRelevance) { return; }
    if (!spec || !spec.sockel) { return; }
    if (window.__lmmSockelQ === q) { return; }
    var sp;
    try { sp = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (sp.get('page')) { return; }
    /* Eigene Filterwahl des Kunden respektieren — nur die von uns gesetzte
       Techstufe (lmm_tech=1) gilt nicht als Kundenfilter. */
    var fremdFilter = false;
    sp.forEach(function (wert, name) {
      if (name.indexOf('filter.') === 0) { fremdFilter = true; }
    });
    if (fremdFilter && sp.get('lmm_tech') !== '1') { return; }
    var sichtbar = 0;
    if (liste) {
      Array.prototype.forEach.call(liste.querySelectorAll('article.prow'), function (el) {
        if (!el.dataset.lmmTechHidden) { sichtbar += 1; }
      });
    }
    if (sichtbar >= SOCKEL_MIN) { return; }
    window.__lmmSockelQ = q;
    var url;
    try { url = new URL(window.location.pathname, window.location.origin); }
    catch (e) { return; }
    url.searchParams.set('q', spec.sockel);
    url.searchParams.set('type', 'product');
    try {
      T.filterParams(spec).forEach(function (paar) { url.searchParams.set(paar[0], paar[1]); });
    } catch (e) { /* ohne Filter weiter — die Verifikation unten prueft hart */ }
    var vorschau = sp.get('preview_theme_id');
    if (vorschau) { url.searchParams.set('preview_theme_id', vorschau); }
    var zielUrl = url.pathname + url.search;
    url.searchParams.set('section_id', LMM_SECTION_ID);
    sucheBeobachten(window.fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (antwort) {
        if (!antwort.ok) { throw new Error('HTTP ' + antwort.status); }
        return antwort.text();
      }), function (html) { sockelEinfuegen(liste, html, spec, T, q, analyse, zielUrl); });
  }

  function sockelEinfuegen(liste, html, spec, T, q, analyse, zielUrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.getElementById('productList');
    var karten = neu ? Array.prototype.slice.call(neu.querySelectorAll('article.prow')) : [];
    if (!karten.length) { return; }
    var bekannt = {};
    if (liste) {
      Array.prototype.forEach.call(liste.querySelectorAll('article.prow'), function (el) {
        var k = schluessel(el);
        if (k) { bekannt[k] = true; }
      });
    }
    /* Verifikation gegen ALLE harten Bedingungen mit der ORIGINALEN Anfrage:
       nur Karten mit exakt belegtem Sockel und ohne jeden Widerspruch. */
    var rein = [];
    karten.forEach(function (el) {
      var k = schluessel(el);
      if (!k || bekannt[k]) { return; }
      var v = null;
      try { v = window.LMMRelevance.rank(analyse, datenVon(el)); } catch (e) { v = null; }
      if (!v || v.hart > 0 || v.sockel !== 0) { return; }
      bekannt[k] = true;
      rein.push(el);
    });
    if (!rein.length) { return; }
    var gesamt = rein.length;
    var summe = doc.getElementById('lmmResultCount');
    if (summe) {
      var tref = /von\s+([\d.]+)/.exec(summe.textContent || '');
      if (tref) {
        var ausText = Number(String(tref[1]).replace(/\./g, ''));
        if (isFinite(ausText) && ausText > gesamt) { gesamt = ausText; }
      }
    }
    var zeige = rein.slice(0, SOCKEL_MAX);
    var sockelName = String(spec.sockel).toUpperCase();
    var ziel = liste && liste.isConnected ? liste : null;
    if (!ziel) {
      /* Kein Produktcontainer (native Suche lieferte nichts): die verifizierte
         Sockelliste ersetzt den leeren Zustand — gleiche Technik wie die
         Schreibweisen-Stufe. */
      var kopie = document.importNode(neu, true);
      Array.prototype.forEach.call(kopie.querySelectorAll('article.prow'), function (el) {
        el.remove();
      });
      zeige.forEach(function (el) {
        var c = document.importNode(el, true);
        c.setAttribute('data-lmm-tech-quelle', 'sockelstufe');
        kopie.appendChild(c);
      });
      var platz = document.getElementById('productList') || document.querySelector('#lmmMain .empty-state');
      if (!platz || !platz.parentNode) { return; }
      platz.parentNode.replaceChild(kopie, platz);
      ziel = kopie;
    } else {
      var hauptTrenner = ziel.querySelector('.type-divider[data-group="leuchtmittel"]')
        || ziel.querySelector('.type-divider');
      var anker = hauptTrenner || null;
      zeige.forEach(function (el) {
        var c = document.importNode(el, true);
        c.setAttribute('data-lmm-tech-quelle', 'sockelstufe');
        if (anker && anker.parentNode) {
          anker.parentNode.insertBefore(c, anker.nextSibling);
          anker = c;
        } else {
          ziel.insertBefore(c, ziel.firstChild);
        }
      });
    }
    var trenner = ziel.querySelector('.type-divider');
    if (trenner && !trenner.querySelector('[data-lmm-sockel-note]')) {
      var hinweis = document.createElement('span');
      hinweis.className = 'td-note';
      hinweis.setAttribute('data-lmm-sockel-note', '1');
      hinweis.textContent = 'Erg\u00e4nzt um gepr\u00fcfte ' + sockelName + '-Artikel.';
      trenner.appendChild(hinweis);
      if (gesamt > zeige.length) {
        var mehr = document.createElement('a');
        mehr.className = 'td-note lmm-tech-mehr';
        mehr.href = zielUrl;
        mehr.textContent = 'Alle ' + gesamt + ' ' + sockelName + '-Artikel anzeigen';
        trenner.appendChild(mehr);
      }
    }
    ersatzMitranken(ziel, analyse);
    ordneListe(ziel, spec, T, analyse);
  }

  /* Ersatzstufe (Chris 2026-07-30, zweite Runde): "Die 7-16W/840 muss doch auch
     kommen." Sie traegt specs.wattage = 7,0 und faellt deshalb durch die strenge
     Stufe. Sie wird als EIGENE, beschriftete Gruppe nachgeladen — nativ ueber
     dieselbe Suche mit specs.replaces_wattage, nicht ueber eine Sonderregel.
     Laeuft nur auf der von uns gesetzten Stufe (lmm_tech=1): Sobald der Kunde
     selbst filtert, wird nichts mehr ergaenzt. */
  /* KORREKTURRUNDE 2 (Chris Phase 6/7/9): Die Ersatzkandidaten wurden bisher
     als stumme Gruppe ans ENDE gehaengt — ohne Rangvektor. Dadurch stand bei
     "16W/840 G13" die echte 7-16W/840-G13-Roehre (ersetzt 16 W) HINTER sechs
     LED-Roehren, die selbst 16 W ziehen, aber 36 beziehungsweise 38 W ersetzen.
     Jetzt werden sie mit demselben Datensatz und derselben Engine bewertet und
     in die gemeinsame Reihenfolge einsortiert; wattstufe trennt Stufe A
     (direkt), Stufe B (verifizierter Ersatz) und Stufe C (falsche Ersatzklasse). */
  function ersatzMitranken(liste, analyse) {
    if (!analyse || !window.LMMRelevance) { return; }
    var neu = liste.querySelectorAll('article.prow[data-lmm-tech-quelle]');
    if (!neu.length) { return; }
    Array.prototype.forEach.call(neu, function (el) {
      if (el.getAttribute('data-lmm-r-klasse') !== null) { return; }
      var v = null;
      try { v = window.LMMRelevance.rank(analyse, datenVon(el)); } catch (fehler) { v = null; }
      if (!v) { return; }
      el.lmmRangVektor = v;
      el.setAttribute('data-lmm-r-klasse', String(v.klasse));
      el.setAttribute('data-lmm-r-warum', v.grund);
      el.setAttribute('data-lmm-r-wattstufe', String(v.wattstufe));
      el.setAttribute('data-lmm-r-technik', String(v.technik));
      el.setAttribute('data-lmm-r-familie', String(v.familie));
      el.setAttribute('data-lmm-r-fehl', String(v.fehl));
      el.setAttribute('data-lmm-r-bewertung', String(v.bewertung));
      el.setAttribute('data-lmm-r-bewertungen', String(v.bewertungen));
    });
  }

  /* Hoechstens so viele Familienkandidaten werden ergaenzt. */
  var FAMILIE_MAX = 12;

  /* FAMILIENSTUFE (Chris Phase 3/4, Korrekturrunde 2).
     Gemessen am 04.08.2026 auf dem Canary: die Rangfolge war fuer alle vier
     Schreibweisen identisch, der von Shopify gelieferte BESTAND aber nicht —
       q="LED Leuchtroehre"      -> 633 Treffer, Seite 1 ausschliesslich Leuchten
       q="LED Tube"              -> roehrenreiner Bestand
     Ein nativer Produkttyp-Filter steht nicht zur Verfuegung: read-only geprueft,
     filter.p.product_type=LED-Roehren aendert die Trefferzahl nicht (633 mit und
     ohne). Deshalb wird — wie bei der bewaehrten Ersatzstufe — der kanonische
     Familienbegriff als ZWEITE native Suche geladen, ueber die Produkt-URL
     dedupliziert, mit derselben Engine bewertet und gemeinsam sortiert.
     Die angezeigte Suchanfrage und der Trefferzaehler bleiben unveraendert. */
  function familienStufeLaden(liste, spec, T, q, analyse) {
    if (!window.fetch || !window.DOMParser || !window.LMMRelevance) { return; }
    var fam = analyse.familie;
    if (!fam || !fam.nativeQuery) { return; }
    if (liste.dataset.lmmFamilie === q) { return; }
    var sp = new URLSearchParams(window.location.search);
    if (sp.get('page')) { return; }
    var eigenerFilter = false;
    sp.forEach(function (wert, name) {
      if (name.indexOf('filter.') === 0) { eigenerFilter = true; }
    });
    if (eigenerFilter) { return; }
    /* Hat der Kunde den kanonischen Begriff selbst getippt, gibt es nichts zu
       vereinheitlichen. */
    try {
      if (window.LMMRelevance.normalize(q) === window.LMMRelevance.normalize(fam.nativeQuery)) { return; }
    } catch (fehler) { return; }
    liste.dataset.lmmFamilie = q;
    var url;
    try { url = new URL(window.location.pathname, window.location.origin); }
    catch (fehler) { return; }
    url.searchParams.set('q', fam.nativeQuery);
    url.searchParams.set('type', 'product');
    var vorschau = sp.get('preview_theme_id');
    if (vorschau) { url.searchParams.set('preview_theme_id', vorschau); }
    var zielUrl = url.pathname + url.search;
    url.searchParams.set('section_id', LMM_SECTION_ID);
    sucheBeobachten(window.fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (antwort) {
        if (!antwort.ok) { throw new Error('HTTP ' + antwort.status); }
        return antwort.text();
      }), function (html) { familienEinfuegen(liste, html, spec, T, q, analyse, zielUrl); });
  }

  function familienEinfuegen(liste, html, spec, T, q, analyse, zielUrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.querySelectorAll('article.prow');
    if (!neu.length) { return; }
    var bekannt = {};
    Array.prototype.forEach.call(liste.querySelectorAll('article.prow'), function (el) {
      var k = schluessel(el);
      if (k) { bekannt[k] = true; }
    });
    var rein = [];
    Array.prototype.forEach.call(neu, function (el) {
      var k = schluessel(el);
      if (!k || bekannt[k]) { return; }
      var v = null;
      try { v = window.LMMRelevance.rank(analyse, datenVon(el)); } catch (fehler) { v = null; }
      /* Nur echte Familienmitglieder werden ergaenzt — eine Leuchte oder ein
         Treiber wuerde die Anfrage nur weiter verwaessern. */
      if (!v || v.familie > 1) { return; }
      bekannt[k] = true;
      rein.push(el);
    });
    if (!rein.length) { return; }
    var gesamt = rein.length;
    var summe = doc.getElementById('lmmResultCount');
    if (summe) {
      var tref = /von\s+([\d.]+)/.exec(summe.textContent || '');
      if (tref) {
        var ausText = Number(String(tref[1]).replace(/\./g, ''));
        if (isFinite(ausText) && ausText > gesamt) { gesamt = ausText; }
      }
    }
    var zeige = rein.slice(0, FAMILIE_MAX);
    var hauptTrenner = liste.querySelector('.type-divider[data-group="leuchtmittel"]')
      || liste.querySelector('.type-divider');
    var anker = hauptTrenner || null;
    zeige.forEach(function (el) {
      var kopie = document.importNode(el, true);
      kopie.setAttribute('data-lmm-tech-quelle', 'familienstufe');
      if (anker && anker.parentNode) {
        anker.parentNode.insertBefore(kopie, anker.nextSibling);
        anker = kopie;
      } else {
        liste.insertBefore(kopie, liste.firstChild);
      }
    });
    if (hauptTrenner && !hauptTrenner.querySelector('[data-lmm-familie-note]')) {
      var hinweis = document.createElement('span');
      hinweis.className = 'td-note';
      hinweis.setAttribute('data-lmm-familie-note', '1');
      hinweis.textContent = 'Erg\u00e4nzt um passende Artikel aus derselben Produktgruppe.';
      hauptTrenner.appendChild(hinweis);
      if (gesamt > zeige.length) {
        var mehr = document.createElement('a');
        mehr.className = 'td-note lmm-tech-mehr';
        mehr.href = zielUrl;
        mehr.textContent = 'Alle ' + gesamt + ' Artikel dieser Produktgruppe anzeigen';
        hauptTrenner.appendChild(mehr);
      }
    }
    ersatzMitranken(liste, analyse);
    ordneListe(liste, spec, T, analyse);
  }

  function ersatzStufeLaden(liste, spec, T, q, analyse) {
    if (!window.fetch || !window.DOMParser) { return; }
    if (liste.dataset.lmmErsatz === q) { return; }
    var paare = T.ersatzFilterParams(spec);
    if (!paare.length) { return; }
    liste.dataset.lmmErsatz = q;
    var url;
    try { url = new URL(window.location.pathname, window.location.origin); }
    catch (e) { return; }
    url.searchParams.set('q', q);
    url.searchParams.set('type', 'product');
    /* append statt set (2026-08-13): die Ersatzklasse liefert MEHRERE
       replaces_wattage-Werte (50/51/…/55) — Shopify ODER-verknuepft
       wiederholte Filterwerte, set() wuerde alle bis auf den letzten
       verwerfen. */
    paare.forEach(function (paar) { url.searchParams.append(paar[0], paar[1]); });
    var vorschau = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (vorschau) { url.searchParams.set('preview_theme_id', vorschau); }
    var zielUrl = url.pathname + url.search;
    url.searchParams.set('section_id', LMM_SECTION_ID);
    sucheBeobachten(window.fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (antwort) {
        if (!antwort.ok) { throw new Error('HTTP ' + antwort.status); }
        return antwort.text();
      }), function (html) { ersatzEinfuegen(liste, html, spec, T, zielUrl, analyse); });
  }

  /* Hoechstens so viele Ersatzprodukte werden angehaengt. Bei "18W/840 G13"
     waeren es sonst 22 zusaetzliche Karten — die exakten Treffer sollen die
     Seite bestimmen. Was NICHT gezeigt wird, steht als Zahl im Trenner und ist
     ueber den Link vollstaendig erreichbar (keine stille Kappung). */
  var ERSATZ_MAX = 8;

  function ersatzEinfuegen(liste, html, spec, T, zielUrl, analyse) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.querySelectorAll('article.prow');
    if (!neu.length) { return; }
    var bekannt = {};
    Array.prototype.forEach.call(liste.querySelectorAll('article.prow'), function (el) {
      var k = schluessel(el);
      if (k) { bekannt[k] = true; }
    });
    var rein = [];
    Array.prototype.forEach.call(neu, function (el) {
      var k = schluessel(el);
      if (!k || bekannt[k]) { return; }
      /* Auch die Ersatzstufe wird klassifiziert — ein GR8-Produkt bleibt bei
         einer G13-Anfrage draussen, und Leuchten ebenso. */
      var klasse = T.classify(spec, datenVon(el));
      if (T.gewicht(spec, klasse.klasse) >= 5) { return; }
      bekannt[k] = true;
      rein.push(el);
    });
    if (!rein.length) { return; }
    /* Gesamtzahl der Ersatzstufe aus der nachgeladenen Seite lesen, damit die
       Kappung sichtbar bleibt statt still zu wirken. */
    var gesamt = rein.length;
    var summe = doc.getElementById('lmmResultCount');
    if (summe) {
      var tref = /von\s+([\d.]+)/.exec(summe.textContent || '');
      if (tref) {
        var ausText = Number(String(tref[1]).replace(/\./g, ''));
        if (isFinite(ausText) && ausText > gesamt) { gesamt = ausText; }
      }
    }
    var zeige = rein.slice(0, ERSATZ_MAX);
    var wattText = String(spec.watt).replace('.', ',');
    /* KORREKTURRUNDE 2 (Chris Phase 6/7/9). Bisher wurden die Ersatzkandidaten
       als eigene Gruppe ans LISTENENDE gehaengt und nie fachlich bewertet.
       Messbar am 04.08.2026 auf dem Canary bei "16W/840 G13":
           1.      1000112325   16 W                konventionell, exakt
           2.-7.                16 W, ersetzt 36/38 W
           --- Gruppe "LED-Ersatz" ---
           8.      1030018431    7 W, ersetzt 16 W  <- der gesuchte Ersatz
       Die echte 16-W-Ersatzroehre stand damit hinter sechs Roehren, die 36
       beziehungsweise 38 W ersetzen. Jetzt werden die Kandidaten in dieselbe
       Gruppe einsortiert und von derselben Engine bewertet; "wattstufe" trennt
       Stufe A (direkte Eigenleistung), Stufe B (verifizierter Ersatz) und
       Stufe C (verbraucht zwar die gesuchte Leistung, ersetzt aber eine andere).
       Die Erklaerung geht nicht verloren — sie wandert an den Gruppentrenner,
       und der Link auf die vollstaendige Ersatzliste bleibt erhalten. */
    var hauptTrenner = liste.querySelector('.type-divider[data-group="leuchtmittel"]')
      || liste.querySelector('.type-divider');
    var anker = null;
    if (hauptTrenner) {
      anker = hauptTrenner;
      var folge = hauptTrenner.nextElementSibling;
      while (folge && !(folge.classList && folge.classList.contains('type-divider'))) {
        anker = folge;
        folge = folge.nextElementSibling;
      }
    }
    zeige.forEach(function (el) {
      var kopie = document.importNode(el, true);
      kopie.setAttribute('data-lmm-tech-quelle', 'ersatzstufe');
      if (anker && anker.parentNode) {
        anker.parentNode.insertBefore(kopie, anker.nextSibling);
        anker = kopie;
      } else {
        liste.appendChild(kopie);
      }
    });
    if (hauptTrenner && !hauptTrenner.querySelector('[data-lmm-ersatz-note]')) {
      var hinweis = document.createElement('span');
      hinweis.className = 'td-note';
      hinweis.setAttribute('data-lmm-ersatz-note', '1');
      /* Wortlaut je Kontext (2026-08-13): die Stufe laeuft jetzt auch fuer
         Spots/Reflektoren \u2014 dort waere "LED-Roehren" schlicht falsch. */
      hinweis.textContent = spec.roehrenKontext
        ? 'Enthaelt LED-Roehren, die eine Leuchtstofflampe mit '
          + wattText + ' W ersetzen \u2014 ihre eigene Leistungsaufnahme ist niedriger.'
        : 'Enthaelt LED-Alternativen, die ca. ' + wattText
          + ' W ersetzen \u2014 ihre eigene Leistungsaufnahme ist niedriger.';
      hauptTrenner.appendChild(hinweis);
      if (gesamt > zeige.length) {
        var mehr = document.createElement('a');
        mehr.className = 'td-note lmm-tech-mehr';
        mehr.href = zielUrl;
        mehr.textContent = spec.roehrenKontext
          ? 'Alle ' + gesamt + ' LED-Ersatzr\u00f6hren anzeigen'
          : 'Alle ' + gesamt + ' LED-Alternativen anzeigen';
        hauptTrenner.appendChild(mehr);
      }
    }
    ersatzMitranken(liste, analyse);
    ordneListe(liste, spec, T, analyse);
  }

  /* ------------------------------------------------------------- SEITENSTUFE */
  /* Grenzwert der Seitenstufe. GEMESSEN, nicht geschaetzt (2026-08-11, Canary
     203799626065, Trefferzahlen NACH der strengen Kandidatenstufe):
         "18W Leuchtstoffroehre durch LED ersetzen"    90 Treffer   4 Seiten
         "LED Roehre die 58W ersetzt"                 105 Treffer   5 Seiten
         "6W E27"                                      82 Treffer   4 Seiten
         "16W/840 G13"                                  9 Treffer   1 Seite
         "LED 6W E27"                                 272 Treffer  12 Seiten
     Vier zusaetzliche Anfragen decken alles bis fuenf Seiten ab und schliessen
     den 12-Seiten-Fall aus. Kosten je Anfrage (section_id, gemessen): rund
     349 kB und 380-540 ms; die Anfragen laufen NACH dem ersten Rendern.
     ENTWEDER wird der verengte Satz VOLLSTAENDIG geladen ODER gar nicht — ein
     halb geladener Satz waere eine stille Kappung, deren Reihenfolge niemand
     erklaeren koennte. Uebersprungene Faelle sind am Container als
     data-lmm-pool="uebersprungen" ablesbar und behalten die native Pagination.
     Breite Anfragen ("LED", "Philips", "Leuchtmittel", "Osram 36W") erreichen
     die Stufe ohnehin nie: sie sind nicht strukturiert, setzen keinen Filter
     und bekommen damit kein lmm_tech=1. */
  var POOL_SEITEN_MAX = 4;
  /* Feste Gruppenreihenfolge — spiegelt group_keys im Liquid oben. Nur noetig,
     wenn eine Folgeseite eine Gruppe enthaelt, die auf Seite 1 fehlt (belegt:
     "zubehoer" erscheint bei Q1 erst auf Seite 2). */
  var POOL_GRUPPEN = ['leuchtmittel', 'leuchte', 'adapter', 'zubehoer'];
  var poolSteuerung = null;

  function poolAbbrechen() {
    if (poolSteuerung) {
      try { poolSteuerung.abort(); } catch (fehler) { /* egal */ }
      poolSteuerung = null;
    }
  }

  /* Anwenden nur, wenn der Kunde oben steht. Scrollt er bereits, wird die
     fertige Nachladung EINMAL gepuffert und angewendet, sobald er wieder oben
     ist — sonst springt ihm die Liste unter dem Finger weg. Dieselbe 8-px-
     Schwelle wie in neuOrdnen. */
  function obenAnwenden(fn) {
    function oben() {
      return (window.pageYOffset || document.documentElement.scrollTop || 0) <= 8;
    }
    if (oben()) { fn(); return; }
    var lauf = function () {
      if (!oben()) { return; }
      window.removeEventListener('scroll', lauf);
      fn();
    };
    window.addEventListener('scroll', lauf, { passive: true });
  }

  /* Seitenzahl des BEREITS verengten Ergebnisses — ohne zusaetzliche Anfrage
     aus "Seite X von Y" der nativen Pagination gelesen. Fehlt die Pagination,
     gibt es nur eine Seite und nichts nachzuladen. */
  function poolSeitenzahl() {
    var status = document.querySelector('.lmm-pagination__status');
    if (!status) { return 1; }
    var treffer = /von\s+(\d+)/.exec(status.textContent || '');
    var n = treffer ? Number(treffer[1]) : 1;
    return isFinite(n) && n > 0 ? n : 1;
  }

  function seitenStufeLaden(liste, spec, T, q, analyse) {
    if (!window.fetch || !window.DOMParser) { return; }
    if (liste.dataset.lmmPool) { return; }
    var seiten = poolSeitenzahl();
    if (seiten < 2) { return; }
    if (seiten > POOL_SEITEN_MAX + 1) {
      /* Keine stille Kappung: der Fall bleibt am Container ablesbar, die native
         Pagination bleibt der vollstaendige Weg fuer den Kunden. */
      liste.dataset.lmmPool = 'uebersprungen';
      liste.dataset.lmmPoolSeiten = String(seiten);
      sortumfangAnzeigen(false);
      return;
    }
    liste.dataset.lmmPool = 'laedt';
    liste.dataset.lmmPoolSeiten = String(seiten);
    var startSearch = window.location.search;
    var basis;
    try { basis = new URLSearchParams(startSearch); } catch (fehler) { return; }
    /* EXAKT dieselben Parameter wie die sichtbare Seite — inklusive aller
       filter.*-Werte und eines etwaigen preview_theme_id. Keine neue
       Suchsemantik, nur eine andere Seite desselben Ergebnisses. */
    basis.delete('page');
    basis.delete('section_id');
    poolAbbrechen();
    poolSteuerung = window.AbortController ? new AbortController() : null;
    var optionen = { headers: { Accept: 'text/html' } };
    if (poolSteuerung) { optionen.signal = poolSteuerung.signal; }
    var anfragen = [];
    for (var s = 2; s <= seiten; s++) {
      var sp2 = new URLSearchParams(basis.toString());
      sp2.set('page', String(s));
      sp2.set('section_id', LMM_SECTION_ID);
      anfragen.push(window.location.pathname + '?' + sp2.toString());
    }
    liste.dataset.lmmPoolAnfragen = String(anfragen.length);
    var lauf = suchLauf;
    sucheBeobachten(Promise.all(anfragen.map(function (adresse) {
      return window.fetch(adresse, optionen)
        .then(function (antwort) { if (!antwort.ok) throw new Error('HTTP ' + antwort.status); return antwort.text(); })
        .catch(function () { if (laufAktiv(lauf)) lauf.failedCount += 1; return ''; });
    })), function (seitenHtml) {
      /* Query oder Filter/Sortierung zwischenzeitlich gewechselt oder Liste abgetrennt?
         Dann gehoert das Ergebnis zur alten Ansicht und wird verworfen. */
      if (!liste.isConnected || window.location.search !== startSearch) { return; }
      if (seitenHtml.length !== anfragen.length || seitenHtml.some(function (h) { return !h; })) {
        liste.dataset.lmmPool = 'fehler';
        sortumfangAnzeigen(false);
        return;
      }
      obenAnwenden(function () {
        if (!laufAktiv(lauf) || !liste.isConnected || window.location.search !== startSearch) { return; }
        seitenEinfuegen(liste, seitenHtml, spec, T, q, analyse);
      });
    });
  }

  /* Gruppentrenner fuer einen Bucket besorgen — vorhandenen benutzen, sonst den
     aus der nachgeladenen Seite an der kanonischen Position einhaengen. */
  function poolGruppe(liste, bucket, quelle) {
    var b = bucket || 'leuchtmittel';
    var da = liste.querySelector('.type-divider[data-group="' + b + '"]');
    if (da) { return da; }
    var vorlage = quelle.querySelector('.type-divider[data-group="' + b + '"]');
    if (!vorlage) { return null; }
    var neu = document.importNode(vorlage, true);
    var pos = POOL_GRUPPEN.indexOf(b);
    var davor = null;
    for (var i = pos + 1; i < POOL_GRUPPEN.length && !davor; i++) {
      davor = liste.querySelector('.type-divider[data-group="' + POOL_GRUPPEN[i] + '"]');
    }
    if (davor) { liste.insertBefore(neu, davor); } else { liste.appendChild(neu); }
    return neu;
  }

  /* Letztes Element der Gruppe, an das angehaengt wird. */
  function poolAnker(trenner) {
    var anker = trenner;
    var folge = trenner.nextElementSibling;
    while (folge && !(folge.classList && folge.classList.contains('type-divider'))) {
      anker = folge;
      folge = folge.nextElementSibling;
    }
    return anker;
  }

  function seitenEinfuegen(liste, seitenHtml, spec, T, q, analyse) {
    var bekannt = {};
    Array.prototype.forEach.call(liste.querySelectorAll('article.prow'), function (el) {
      var k = schluessel(el);
      if (k) { bekannt[k] = true; }
    });
    var eingefuegt = 0;
    var doppelt = 0;
    seitenHtml.forEach(function (html) {
      if (!html) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* NUR die Produktkarten werden uebernommen — kein Footer, keine
         Pagination, keine zweite Section. */
      Array.prototype.forEach.call(doc.querySelectorAll('article.prow'), function (el) {
        var k = schluessel(el);
        if (!k) { return; }
        if (bekannt[k]) { doppelt += 1; return; }
        var trenner = poolGruppe(liste, el.getAttribute('data-ptype'), doc);
        if (!trenner) { return; }
        bekannt[k] = true;
        var kopie = document.importNode(el, true);
        /* Herkunft nur als Nachweis — sie geht NICHT in die Rangfolge ein.
           Seite 1 ist nicht wichtiger als Seite 2 bis 4. */
        kopie.setAttribute('data-lmm-tech-quelle', 'seitenstufe');
        var anker = poolAnker(trenner);
        if (anker.parentNode) { anker.parentNode.insertBefore(kopie, anker.nextSibling); }
        eingefuegt += 1;
      });
    });
    liste.dataset.lmmPool = eingefuegt ? 'vollstaendig' : 'leer';
    liste.dataset.lmmPoolNeu = String(eingefuegt);
    liste.dataset.lmmPoolDoppelt = String(doppelt);
    if (!eingefuegt) { sortumfangAnzeigen(poolVollstaendig(liste)); return; }
    /* Der vollstaendige verengte Satz steht jetzt auf dieser Seite. Eine
       Pagination, die weiterhin "Seite 1 von 4" anbietet, waere ab hier falsch:
       ihre Folgeseiten enthalten ausschliesslich Produkte, die bereits oben
       stehen. Sie wird entfernt; zaehlerNachziehen formuliert den Zaehler
       daraufhin von selbst als "1-N von N Treffern". */
    var seiten = document.querySelector('.lmm-pagination');
    if (seiten && seiten.parentNode) { seiten.parentNode.removeChild(seiten); }
    /* Ein einziger gemeinsamer Rangdurchlauf ueber ALLE Kandidaten — dieselbe
       Engine, dieselben harten Bedingungen, dieselbe Bewertungs- und
       Bestsellerkaskade wie fuer die Karten der ersten Seite. */
    ordneListe(liste, spec, T, analyse);
    sortumfangAnzeigen(poolVollstaendig(liste));
  }

  /* Sortier-UI (Chris 2026-08-13): Auswahl aus lmm_sort spiegeln, natives
     sort_by NUR fuer die Preis-Modi aktivieren (disabled-Inputs fehlen in der
     FormData des PJAX-Handlers in lmm-collection.js), lmm_tech als Formular-
     zustand mitfuehren und lmm_sort an die Paginierungslinks haengen —
     Liquid kennt den eigenen Parameter nicht. Die Navigation beim Wechsel
     uebernimmt weiterhin der bestehende [data-lmm-sort]-Handler (PJAX). */
  function sortUiInit() {
    var form = document.querySelector('[data-lmm-sortform]');
    if (!form) { return; }
    var select = form.querySelector('select[name="lmm_sort"]');
    var nativ = form.querySelector('[data-lmm-sort-native]');
    var sp;
    try { sp = new URLSearchParams(window.location.search); } catch (fehler) { return; }
    var wahl = sp.get('lmm_sort');
    if (select && wahl) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === wahl) { select.value = wahl; break; }
      }
    }
    function nativAbgleichen() {
      if (!nativ || !select) { return; }
      var preis = select.value === 'price-ascending' || select.value === 'price-descending';
      nativ.disabled = !preis;
      if (preis) { nativ.value = select.value; }
    }
    nativAbgleichen();
    if (select && !select.dataset.lmmSortInit) {
      select.dataset.lmmSortInit = '1';
      /* Capture-Phase laeuft VOR dem PJAX-Bubble-Handler. */
      select.addEventListener('change', nativAbgleichen, true);
    }
    var tech = sp.get('lmm_tech');
    if (tech !== null && !form.querySelector('input[name="lmm_tech"]')) {
      var t = document.createElement('input');
      t.type = 'hidden'; t.name = 'lmm_tech'; t.value = tech;
      form.appendChild(t);
    }
    if (wahl) {
      var anhang = 'lmm_sort=' + encodeURIComponent(wahl);
      Array.prototype.forEach.call(document.querySelectorAll('.lmm-pagination__link[href]'), function (a) {
        var href = a.getAttribute('href') || '';
        if (href.indexOf('lmm_sort=') === -1) {
          a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + anhang);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ordne, { once: true });
    document.addEventListener('DOMContentLoaded', sortUiInit, { once: true });
  } else {
    ordne();
    sortUiInit();
  }
  /* Nach einem PJAX-Filterwechsel ist die Liste neu — erneut ordnen. Eine noch
     laufende Seitenstufe gehoert zur alten Anfrage und wird abgebrochen, damit
     ihre Karten nicht in das neue Ergebnis geraten. */
  document.addEventListener('lmm:content-swapped', poolAbbrechen);
  /* TUEV-21 (Chris 2026-08-17): ordne() laeuft nach einem Swap NICHT mehr
     synchron im Handler, sondern in einem Microtask.
     Belegte Ursache des Dropdown-Sortierfehlers: assets/lmm-collection.js
     dispatcht lmm:content-swapped in swapAll() und ruft history.pushState()
     erst DANACH auf. Synchron im Handler ist window.location.search deshalb
     noch die ALTE URL. sortModus() lieferte damit den VORIGEN Modus, und die
     serverseitig korrekt preissortierte Liste wurde nach der Bestsellerkaskade
     umsortiert — live gemessen 0,99 -> 0,87 -> 0,67 statt aufsteigend, waehrend
     Dropdown und URL bereits "Preis aufsteigend" zeigten. Der Modus lief dem
     Klick genau eine Auswahl nach; betroffen war jeder Wechsel zwischen
     Preis-Modi und den uebrigen Sortierungen in beiden Richtungen.
     Ein Microtask laeuft nach Abschluss des laufenden Jobs — also nach
     pushState — und noch VOR dem Rendering. Damit liest ordne() die richtige
     URL, ohne sichtbares Umspringen und ohne Full Reload. Das korrigiert
     zugleich die uebrigen URL-Lesungen in ordne() (q, lmm_tech, page), die
     bisher demselben veralteten Stand folgten.
     Fehlt Promise (sehr alte Browser), bleibt das bisherige synchrone
     Verhalten. Die Reihenfolge zu poolAbbrechen bleibt gewahrt: erst
     abbrechen, dann ordnen. assets/lmm-collection.js wird NICHT geaendert —
     Collections sortieren serverseitig ueber sort_by und sind nachgemessen
     unauffaellig. */
  document.addEventListener('lmm:content-swapped', function () {
    if (typeof Promise === 'function') { Promise.resolve().then(ordne); return; }
    ordne();
  });
  /* TUEV-21 Nachtrag (Chris 2026-08-17): Die Spiegelung URL -> Select laeuft
     nach einem Swap im Microtask, nicht mehr synchron.
     Gemessen auf MAIN 203266064721: lmm-collection.js dispatcht
     lmm:content-swapped VOR history.pushState() (dieselbe Ursache wie beim
     bereits behobenen Reihenfolgefehler). Der Swap liefert eine FRISCH
     servergerenderte Select-Box, deren Auswahl aus sort_by stammt und fuer die
     Preis-Modi bereits korrekt ist — belegt per Roh-HTML: sort_by=price-descending
     rendert selected=price-descending. Der synchrone sortUiInit() las dann die
     ALTE URL und schrieb den vorigen lmm_sort-Wert darueber, machte die korrekte
     Auswahl also wieder falsch; ohne lmm_sort in der alten URL war er dagegen
     wirkungslos. Korrigiert hat das erst setTimeout(..., 150) — sichtbar sprang
     die Beschriftung auf den vorigen Modus zurueck, obwohl Liste und URL schon
     stimmten.
     Im Microtask laeuft die Spiegelung nach pushState und noch VOR dem
     Rendering; damit ist der sichtbare Wert ohne Zwischenzustand korrekt.
     Der Timer bleibt als idempotenter Fallback: sortUiInit stellt auch das
     native sort_by, den lmm_tech-Formularzustand und die lmm_sort-Anhaenge der
     frisch gerenderten Paginierungslinks her, und ein spaeter Lauf liest immer
     die AKTUELLE URL — er kann daher keinen veralteten Wert zurueckschreiben.
     Fehlt Promise, bleibt das bisherige synchrone Verhalten. ordne(), Ranking,
     Router, Preislogik und lmm-collection.js bleiben unberuehrt. */
  document.addEventListener('lmm:content-swapped', function () {
    if (typeof Promise === 'function') { Promise.resolve().then(sortUiInit); }
    else { sortUiInit(); }
    window.setTimeout(sortUiInit, 150);
  });
  /* Neue Bestseller-Raenge: nur nachsortieren, nichts nachladen. */
  document.addEventListener('lmm:bestseller-index-updated', neuOrdnen);
})();
